import { s } from "@kosmod/pancake";
import { PlayerID } from "@kosmod/sesame";
import { define } from "./define";

export const hitpointsLogic = define('hitpoints', s.o({
  current: s.num,
  maximum: s.num,
  // Special D&D hack
  temporary: s.num,
}))

export const heroLogic = define('hero', s.o({
  player: s.optional(PlayerID),
}))

export const monsterLogic = define('monster', s.o({
  sourceRef: s.bool,
}))

export const characterLogic = define('character', s.o({
  name: s.str,
}))

export const movementLogic = define('movement', s.o({
  method: s.lu([
    'none',
    'walking',
    'flying'
  ]),
  speed: s.num,
}))

export const adventureLogic = [
  hitpointsLogic,
  heroLogic,
  monsterLogic,
  characterLogic,
  movementLogic,
] as const;


export const AdventureLogicState = s.du('key', {
  [hitpointsLogic.key]: { data: hitpointsLogic.state },
  [heroLogic.key]: { data: heroLogic.state },
  [monsterLogic.key]: { data: monsterLogic.state },
  [characterLogic.key]: { data: characterLogic.state },
  [movementLogic.key]: { data: movementLogic.state },
})